import { Grid, Card, Text, Title } from '@mantine/core';

const DashboardResumen = ({ procesosEvaluativos, planesEstrategicos, objetivosEstrategicos, usuarios }) => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card>
          <Title order={4}>Procesos Activos</Title>
          <Text size="xl" fw={700}>
            {procesosEvaluativos?.filter((p) => p.estado === 'activo').length}
          </Text>
        </Card>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card>
          <Title order={4}>Planes Estratégicos</Title>
          <Text size="xl" fw={700}>
            {planesEstrategicos?.filter((p) => p.estado === 'activo').length}
          </Text>
        </Card>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card>
          <Title order={4}>Objetivos Estratégicos</Title>
          <Text size="xl" fw={700}>
            {objetivosEstrategicos?.length}
          </Text>
        </Card>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card>
          <Title order={4}>Usuarios Activos</Title>
          <Text size="xl" fw={700}>
            {usuarios?.filter((u) => u.estado === 'activo').length}
          </Text>
        </Card>
      </Grid.Col>
    </Grid>
  );
};

export default DashboardResumen;
